import Button from "@mui/material/Button";
import DownloadIcon from '@mui/icons-material/GetApp';
import { ViewSidebar } from '@mui/icons-material';
import { CreateButton, FilterButton } from "react-admin";
import { Card, CardContent } from "@mui/material";
import { useState } from "react";

import { Datagrid, EmailField, List, TextField, TextInput, TopToolbar, FilterList, FilterListItem } from "react-admin";
import { API } from "../../providers/api.provider";
import { endOfToday, startOfToday, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from "date-fns";
import { ImportUsersButton } from "../../components/import-users-button.component";
import { LocalizedDateField } from "../../components/localized-date-field.component";
const usersFilters = [
  <TextInput label="Buscar nome" source="name" alwaysOn />,
  <TextInput label="Buscar email" source="email" />,
  <TextInput label="Buscar usuário" source="username" />,
  <TextInput label="Buscar CPF/CNPJ" source="registration" />,
];

const ListActions = (props: any) => {
  const { className, showSidebar, setShowSidebar } = props;
  return (
    <TopToolbar className={className}>
      <FilterButton />
      <Button
        color="primary"
        onClick={() => setShowSidebar(!showSidebar)}
      >
        <ViewSidebar style={{ marginRight: 8 }} />
        {showSidebar ? 'Ocultar' : 'Mostrar'} Filtros
      </Button>
      <Button
        color="primary"
        onClick={async () =>
          API.get("/admin/tasks/export-users", { responseType: "blob" }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "usuarios.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
          })
        }
      >
        <DownloadIcon style={{ marginRight: 8 }} />
        Exportar
      </Button>
      <ImportUsersButton />
      <CreateButton />
    </TopToolbar>
  );
};

const UsersSidebar = () => (
  <Card style={{ width: 250, marginRight: 16, order: -1 }}>
    <CardContent>
      <FilterList label="Criado" icon={null}>
        <FilterListItem
          label="Hoje"
          value={{
            createdAtStart: startOfToday().toISOString(),
            createdAtEnd: endOfToday().toISOString(),
          }}
        />
        <FilterListItem
          label="Esta semana"
          value={{
            createdAtStart: startOfWeek(new Date()).toISOString(),
            createdAtEnd: endOfWeek(new Date()).toISOString(),
          }}
        />
        <FilterListItem
          label="Este mês"
          value={{
            createdAtStart: startOfMonth(new Date()).toISOString(),
            createdAtEnd: endOfMonth(new Date()).toISOString(),
          }}
        />
      </FilterList>
      <FilterList label="Atualizado" icon={null}>
        <FilterListItem
          label="Hoje"
          value={{
            updatedAtStart: startOfToday().toISOString(),
            updatedAtEnd: endOfToday().toISOString(),
          }}
        />
        <FilterListItem
          label="Esta semana"
          value={{
            updatedAtStart: startOfWeek(new Date()).toISOString(),
            updatedAtEnd: endOfWeek(new Date()).toISOString(),
          }}
        />
        <FilterListItem
          label="Este mês"
          value={{
            updatedAtStart: startOfMonth(new Date()).toISOString(),
            updatedAtEnd: endOfMonth(new Date()).toISOString(),
          }}
        />
      </FilterList>
    </CardContent>
  </Card>
);

export const UserList = (props: any) => {
  const [showSidebar, setShowSidebar] = useState(true);
  
  return (
  <List 
    {...props} 
    filters={usersFilters} 
    actions={<ListActions showSidebar={showSidebar} setShowSidebar={setShowSidebar} />} 
    aside={showSidebar ? <UsersSidebar /> : null}
  >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Nome" />
      <EmailField source="email" label="E-mail" />
      <TextField source="username" label="Usuário" />
      <TextField source="registration" label="CPF/CNPJ" />      
      <LocalizedDateField source="createdAt" label="Data de Criação" showTime={false}/>      
      <LocalizedDateField source="updatedAt" label="Data de Atualização" showTime={false}/>      
    </Datagrid>
  </List>
);};
